import React from 'react';
import Icon from '../../../components/AppIcon';

const SegmentFilter = ({ filters, onFilterChange }) => {
  const segments = [
    { value: '', label: 'All Segments', icon: 'Users' },
    { value: 'high_value', label: 'High-Value Clients', icon: 'TrendingUp' },
    { value: 'repeat', label: 'Repeat Clients', icon: 'Repeat' },
    { value: 'at_risk', label: 'At-Risk Clients', icon: 'AlertTriangle' },
    { value: 'all_clients', label: 'All Clients', icon: 'Globe' }
  ];

  const statuses = [
    { value: '', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'draft', label: 'Draft' },
    { value: 'archived', label: 'Archived' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-wrap gap-4">
        <div className="flex-1 min-w-[250px]">
          <label className="block text-sm font-medium text-foreground mb-2">
            Client Segment
          </label>
          <div className="flex gap-2 flex-wrap">
            {segments?.map((segment) => (
              <button
                key={segment?.value}
                onClick={() => onFilterChange({ ...filters, segment: segment?.value })}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-smooth press-effect focus-ring ${
                  filters?.segment === segment?.value
                    ? 'bg-primary text-primary-foreground border-primary'
                    : 'bg-background text-foreground border-border hover:bg-muted'
                }`}
              >
                <Icon name={segment?.icon} size={16} />
                <span className="text-sm">{segment?.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="w-48">
          <label className="block text-sm font-medium text-foreground mb-2">
            Status
          </label>
          <select
            value={filters?.status}
            onChange={(e) => onFilterChange({ ...filters, status: e?.target?.value })}
            className="w-full px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-background text-foreground"
          >
            {statuses?.map((status) => (
              <option key={status?.value} value={status?.value}>
                {status?.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SegmentFilter;